import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0" style={{ fontSize: '1rem'}}>
          <p style={{ textAlign: "left" }}>
          Our goal is simple. <br/><br/>
          <span className="purple" style={{ fontSize: '1.5rem', display: 'block', margin: '0 auto', width: 'fit-content'}}>
            "Let's create more Opportunities Together."</span><br/><br/>

          Fontana is a realm dedicated to creating and delivering passive income opportunities for it's community. 
          At Fontana's core is a commitment to leveraging blockchain technology to build a more equitable, engaging and inclusive financial future.
          <br/><br/>
          Our journey is starting, Fontana look forward to partner with industry-leading experts to bring this vision to life. 
          We will continously seek opputunaties to partner with solutions where our community can benifit, may it be real world or on chain world we will look for feasible opportunities. Through these strategic partnerships,
          Fontana is committed to providing innovative and sustainable passive income opportunities, empowering our community to thrive in the decentralized economy. 
          Driven by the team and the community, Fontana will commit for empowering individuals, to achieve their aspirations.

          <br/><br/>
          We envision a diverse ecosystem designed to provide a range of interconnected experiences and opportunities:
          <br/><br/>
           --Fontana Team. Web V1.0
          </p>
          <footer className="blockquote-footer"></footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
